import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/login'
import Active from '@/views/active'
import Orders from '@/views/orders'
import Users from '@/views/users'
import Goods from '@/views/goodsInfo'
import Zhekou from '@/views/zhekou'
import Vips from '@/views/vips'
import Notice from '@/views/notice'
import Huodong from '@/views/huodong'
import Choujiangquan from '@/views/choujiangquan'
import ChoujiangRecord from '@/views/ChoujiangRecord'
import HuodongRecord from '@/views/HuodongRecord'
import PrintNo from '@/views/printNo'
import Shop from '@/views/shop'
import ShopStock from '@/views/shopStock'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/Zhekou',
      name: 'Zhekou',
      component: Zhekou
    },
    {
      path: '/Notice',
      name: 'Notice',
      component: Notice
    },
    {
      path: '/HuodongRecord',
      name: 'HuodongRecord',
      component: HuodongRecord
    },
    {
      path: '/ChoujiangRecord',
      name: 'ChoujiangRecord',
      component: ChoujiangRecord
    },
    {
      path: '/Huodong',
      name: 'Huodong',
      component: Huodong
    },
    {
      path: '/Choujiangquan',
      name: 'Choujiangquan',
      component: Choujiangquan
    },
    {
      path: '/Vips',
      name: 'Vips',
      component: Vips
    },
    {
      path: '/',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/Active',
      name: 'Active',
      component: Active
    },
    {
      path: '/Users',
      name: 'Users',
      component: Users
    },
    {
      path: '/Goods',
      name: 'Goods',
      component: Goods
    },
    {
      path: '/PrintNo',
      name: 'PrintNo',
      component: PrintNo
    },
    {
      path: '/Shop',
      name: 'Shop',
      component: Shop
    },
    {
      path: '/ShopStock',
      name: 'ShopStock',
      component: ShopStock
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js